import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/crystaSureLogo.svg'
import _imports_1 from '@/assets/crystaSureShield.svg'
import _imports_2 from '@/assets/leftarrow.svg'
import _imports_3 from '@/assets/rightarrow.svg'
import _imports_4 from '@/assets/settings.svg'


const _hoisted_1 = { id: "body-container" }
const _hoisted_2 = { class: "SessionPopup" }
const _hoisted_3 = { class: "lg:flex mainlogo" }
const _hoisted_4 = { class: "text-lg font-bold" }
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "crystaSureLogo"
}
const _hoisted_6 = {
  key: 1,
  src: _imports_1,
  alt: "",
  class: "crystaSureShield"
}
const _hoisted_7 = { class: "flex controlalign navchild items-center hover:text-white py-1.5" }
const _hoisted_8 = {
  key: 0,
  class: "bg-tooltip absolute z-50 group-hover:opacity-100 rounded tooltipwidth pointer-events-none transform-y-top left-11 whitespace-nowrap"
}
const _hoisted_9 = { class: "flex controlalign navchild items-center hover:text-white py-1.5" }
const _hoisted_10 = {
  key: 0,
  class: "bg-tooltip absolute z-50 group-hover:opacity-100 rounded tooltipwidth pointer-events-none transform-y-top left-11 whitespace-nowrap"
}
const _hoisted_11 = { class: "flex controlalign navchild items-center hover:text-white py-1.5" }
const _hoisted_12 = {
  key: 0,
  class: "bg-tooltip absolute z-50 group-hover:opacity-100 rounded tooltipwidth pointer-events-none transform-y-top left-11 whitespace-nowrap"
}
const _hoisted_13 = { class: "bottomUl" }
const _hoisted_14 = { class: "relative" }
const _hoisted_15 = {
  key: 0,
  class: "setting"
}
const _hoisted_16 = {
  key: 0,
  class: "item-name leading-5 text-sm text-black"
}
const _hoisted_17 = {
  key: 1,
  class: "setting"
}
const _hoisted_18 = {
  key: 0,
  class: "item-name leading-5 text-sm text-black"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_SessionPopup = _resolveComponent("SessionPopup")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_detailsModalHost = _resolveComponent("detailsModalHost")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavBar, {
      class: _normalizeClass({active:'bg-dark'})
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SessionPopup)
    ]),
    (_ctx.isSessionPopupVisible==true)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["overlay", { active: 'isOverlayActive' }])
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "flex bg-dark",
      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.closeApps()))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass({ 'w-40': _ctx.isSidebarToggle, 'w-10': !_ctx.isSidebarToggle })
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            (_ctx.isSidebarToggle)
              ? (_openBlock(), _createElementBlock("img", _hoisted_5))
              : (_openBlock(), _createElementBlock("img", _hoisted_6))
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["fixed sidebar bg-white sidenav sideheight flex flex-col justify-between h-full z-51", { 'w-40': _ctx.isSidebarToggle, 'w-10': !_ctx.isSidebarToggle ,active:'bg-dark-blue'}])
        }, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigate('root-Frameworks', 'root-Frameworks'))),
              onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sidebar.root_Frameworks = true)),
              onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sidebar.root_Frameworks = false)),
              class: _normalizeClass(["cursor-pointer text-black hover:bg-primary svg-icon pl-2 pr-2.5 adjustWidthWhenHover", _ctx.selectedOptionName === 'root-Frameworks' ? 'bg-primary text-white font-bold a svg-icon123 adjustWidthWhenHover' : 'text-black font-normal adjustWidthWhenHover'])
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("a", _hoisted_7, [
                  _cache[15] || (_cache[15] = _createStaticVNode("<div class=\"py-0.5\" data-v-727789cc><svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-727789cc><g clip-path=\"url(#clip0_2328_26181)\" data-v-727789cc><path d=\"M5.02793 2.80666L1.13449 4.48927L1.12968 5.06084L1.12646 5.63402H1.67074H2.21342L2.22305 5.70627C2.24553 5.87003 2.37879 6.04985 2.53613 6.12692L2.62765 6.17188H8.96954H15.3114L15.3869 6.13655C15.5539 6.05949 15.6968 5.87646 15.716 5.71269L15.7257 5.63402H16.2539H16.7805L16.7773 5.06245L16.7725 4.49087L12.8646 2.80666C10.7164 1.88026 8.94867 1.12245 8.93903 1.12405C8.9294 1.12405 7.16972 1.88187 5.02793 2.80666Z\" fill=\"black\" data-v-727789cc></path><path d=\"M3.19769 10.1138V13.4822L2.89746 13.4902C2.61006 13.4967 2.5908 13.4999 2.49768 13.5416C2.37887 13.5946 2.25042 13.7198 2.19905 13.8322C2.16533 13.9061 2.16212 13.9382 2.1573 14.2689L2.15088 14.627H8.95998H15.7691V14.2818C15.7691 13.9767 15.7659 13.9285 15.737 13.8515C15.6904 13.7262 15.57 13.5994 15.4448 13.5432C15.3484 13.4999 15.3308 13.4967 15.0434 13.4902L14.7415 13.4822V10.1138V6.74374H13.6899H12.6383V10.1154V13.487H12.1245H11.6107V10.1154V6.74374H10.5591H9.50747V10.1154V13.487H8.9937H8.47992V10.1154V6.74374H7.42829H6.37667V10.1154V13.487H5.86289H5.34912V10.1154V6.74374H4.27341H3.19769V10.1138Z\" fill=\"black\" data-v-727789cc></path><path d=\"M1.51675 15.2197C1.36262 15.2727 1.24542 15.3754 1.17156 15.5263C1.13463 15.597 1.13463 15.6114 1.12982 16.236L1.125 16.875H8.95362H16.7838L16.7774 16.252L16.7726 15.6307L16.7277 15.5328C16.6731 15.414 16.5462 15.2855 16.4354 15.2341L16.3552 15.1972L8.97771 15.194C1.91172 15.1908 1.59703 15.1908 1.51675 15.2197Z\" fill=\"black\" data-v-727789cc></path></g><defs data-v-727789cc><clipPath id=\"clip0_2328_26181\" data-v-727789cc><rect width=\"18\" height=\"18\" fill=\"white\" data-v-727789cc></rect></clipPath></defs></svg></div>", 1)),
                  (_ctx.isSidebarToggle)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["item-name leading-5 text-sm pl-2.5", _ctx.selectedOptionName === 'root-Frameworks'? 'text-white font-bold' : 'text-listIconColor font-normal'])
                      }, "Frameworks", 2))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.sidebar.root_Frameworks && !_ctx.isSidebarToggle)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["px-2 text-white", _ctx.selectedOptionName === 'root-Frameworks'?'font-bold':'font-normal'])
                    }, "Frameworks", 2)
                  ]))
                : _createCommentVNode("", true)
            ], 34),
            _createElementVNode("li", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigate('root-controls', 'root-controls'))),
              onMouseenter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sidebar.root_controls = true)),
              onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sidebar.root_controls = false)),
              class: _normalizeClass(["cursor-pointer text-black hover:bg-primary svg-icon pl-2 pr-2.5 adjustWidthWhenHover mt-1", _ctx.selectedOptionName === 'root-controls' ? 'bg-primary text-white font-bold a svg-icon123 adjustWidthWhenHover' : 'text-black font-normal adjustWidthWhenHover'])
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("a", _hoisted_9, [
                  _cache[16] || (_cache[16] = _createElementVNode("div", { class: "py-0.5" }, [
                    _createElementVNode("svg", {
                      width: "18",
                      height: "18",
                      viewBox: "0 0 18 18",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        d: "M5.29463 2.10857C5.26034 2.07416 5.21959 2.04685 5.17472 2.02822C5.12985 2.00959 5.08174 2 5.03316 2C4.98457 2 4.93647 2.00959 4.8916 2.02822C4.84673 2.04685 4.80598 2.07416 4.77168 2.10857L2.81277 4.0561L2.11448 3.37565C2.08019 3.34124 2.03944 3.31393 1.99457 3.2953C1.9497 3.27667 1.90159 3.26708 1.85301 3.26708C1.80442 3.26708 1.75632 3.27667 1.71145 3.2953C1.66658 3.31393 1.62583 3.34124 1.59153 3.37565L1.10857 3.85922C1.07416 3.89352 1.04685 3.93427 1.02822 3.97914C1.00959 4.02401 1 4.07211 1 4.1207C1 4.16928 1.00959 4.21739 1.02822 4.26226C1.04685 4.30713 1.07416 4.34788 1.10857 4.38217L2.57252 5.84028C2.6456 5.90974 2.74256 5.94847 2.84338 5.94847C2.9442 5.94847 3.04117 5.90974 3.11424 5.84028L3.59381 5.35978L5.81481 3.13909C5.88401 3.06984 5.92311 2.97609 5.92363 2.87819C5.92415 2.78028 5.88604 2.68613 5.81758 2.61614L5.29463 2.10857ZM5.29463 7.00554C5.26034 6.97112 5.21959 6.94382 5.17472 6.92519C5.12985 6.90655 5.08174 6.89696 5.03316 6.89696C4.98457 6.89696 4.93647 6.90655 4.8916 6.92519C4.84673 6.94382 4.80598 6.97112 4.77168 7.00554L2.81277 8.96568L2.11448 8.28584C2.08019 8.25143 2.03944 8.22412 1.99457 8.20549C1.9497 8.18686 1.90159 8.17727 1.85301 8.17727C1.80442 8.17727 1.75632 8.18686 1.71145 8.20549C1.66658 8.22412 1.62583 8.25143 1.59153 8.28584L1.10857 8.76849C1.07416 8.80279 1.04685 8.84354 1.02822 8.88841C1.00959 8.93328 1 8.98138 1 9.02997C1 9.07855 1.00959 9.12666 1.02822 9.17153C1.04685 9.2164 1.07416 9.25715 1.10857 9.29144L2.56883 10.7526C2.64185 10.8221 2.73877 10.8608 2.83954 10.8608C2.9403 10.8608 3.03722 10.8221 3.11024 10.7526L3.5932 10.27L5.8142 8.04836C5.88313 7.97959 5.9221 7.88636 5.92262 7.78899C5.92314 7.69162 5.88517 7.59799 5.81697 7.52849L5.29463 7.00554ZM2.96874 12.3369C2.15386 12.3369 1.47402 12.9982 1.47402 13.8134C1.47402 14.6286 2.15447 15.29 2.96874 15.29C3.36034 15.29 3.73591 15.1344 4.01282 14.8575C4.28973 14.5806 4.4453 14.205 4.4453 13.8134C4.4453 13.4218 4.28973 13.0462 4.01282 12.7693C3.73591 12.4924 3.36034 12.3369 2.96874 12.3369ZM16.2578 12.829H7.39843C7.26789 12.829 7.1427 12.8809 7.0504 12.9732C6.9581 13.0655 6.90624 13.1907 6.90624 13.3212V14.3056C6.90624 14.4361 6.9581 14.5613 7.0504 14.6536C7.1427 14.7459 7.26789 14.7978 7.39843 14.7978H16.2578C16.3883 14.7978 16.5135 14.7459 16.6058 14.6536C16.6981 14.5613 16.75 14.4361 16.75 14.3056V13.3212C16.75 13.1907 16.6981 13.0655 16.6058 12.9732C16.5135 12.8809 16.3883 12.829 16.2578 12.829ZM16.2578 2.98528H7.39843C7.26789 2.98528 7.1427 3.03714 7.0504 3.12944C6.9581 3.22174 6.90624 3.34693 6.90624 3.47747V4.46185C6.90624 4.59238 6.9581 4.71757 7.0504 4.80988C7.1427 4.90218 7.26789 4.95403 7.39843 4.95403H16.2578C16.3883 4.95403 16.5135 4.90218 16.6058 4.80988C16.6981 4.71757 16.75 4.59238 16.75 4.46185V3.47747C16.75 3.34693 16.6981 3.22174 16.6058 3.12944C16.5135 3.03714 16.3883 2.98528 16.2578 2.98528ZM16.2578 7.90716H7.39843C7.26789 7.90716 7.1427 7.95902 7.0504 8.05132C6.9581 8.14362 6.90624 8.26882 6.90624 8.39935V9.38373C6.90624 9.51426 6.9581 9.63945 7.0504 9.73176C7.1427 9.82406 7.26789 9.87592 7.39843 9.87592H16.2578C16.3883 9.87592 16.5135 9.82406 16.6058 9.73176C16.6981 9.63945 16.75 9.51426 16.75 9.38373V8.39935C16.75 8.26882 16.6981 8.14362 16.6058 8.05132C16.5135 7.95902 16.3883 7.90716 16.2578 7.90716Z",
                        fill: "black"
                      })
                    ])
                  ], -1)),
                  (_ctx.isSidebarToggle)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["item-name leading-5 text-sm pl-2", _ctx.selectedOptionName === 'root-controls' ? 'text-white font-bold' : 'text-listIconColor font-normal'])
                      }, "Internal Controls", 2))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.sidebar.root_controls && !_ctx.isSidebarToggle)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["px-2 text-white", _ctx.selectedOptionName === 'root-controls'?'font-bold':'font-normal'])
                    }, "Internal Controls", 2)
                  ]))
                : _createCommentVNode("", true)
            ], 34),
            _createElementVNode("li", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.navigate('root-kpis', 'root-kpis'))),
              onMouseenter: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sidebar.root_kpis = true)),
              onMouseleave: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sidebar.root_kpis = false)),
              class: _normalizeClass(["cursor-pointer text-black hover:bg-primary svg-icon pl-2 pr-2.5 adjustWidthWhenHover mt-1", _ctx.selectedOptionName === 'root-kpis' ? 'bg-primary text-white font-bold a svg-icon123 adjustWidthWhenHover' : 'text-black font-normal adjustWidthWhenHover'])
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("a", _hoisted_11, [
                  _cache[17] || (_cache[17] = _createStaticVNode("<div class=\"py-0.5\" data-v-727789cc><svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-727789cc><g clip-path=\"url(#clip0_2328_26181)\" data-v-727789cc><path d=\"M5.02793 2.80666L1.13449 4.48927L1.12968 5.06084L1.12646 5.63402H1.67074H2.21342L2.22305 5.70627C2.24553 5.87003 2.37879 6.04985 2.53613 6.12692L2.62765 6.17188H8.96954H15.3114L15.3869 6.13655C15.5539 6.05949 15.6968 5.87646 15.716 5.71269L15.7257 5.63402H16.2539H16.7805L16.7773 5.06245L16.7725 4.49087L12.8646 2.80666C10.7164 1.88026 8.94867 1.12245 8.93903 1.12405C8.9294 1.12405 7.16972 1.88187 5.02793 2.80666Z\" fill=\"black\" data-v-727789cc></path><path d=\"M3.19769 10.1138V13.4822L2.89746 13.4902C2.61006 13.4967 2.5908 13.4999 2.49768 13.5416C2.37887 13.5946 2.25042 13.7198 2.19905 13.8322C2.16533 13.9061 2.16212 13.9382 2.1573 14.2689L2.15088 14.627H8.95998H15.7691V14.2818C15.7691 13.9767 15.7659 13.9285 15.737 13.8515C15.6904 13.7262 15.57 13.5994 15.4448 13.5432C15.3484 13.4999 15.3308 13.4967 15.0434 13.4902L14.7415 13.4822V10.1138V6.74374H13.6899H12.6383V10.1154V13.487H12.1245H11.6107V10.1154V6.74374H10.5591H9.50747V10.1154V13.487H8.9937H8.47992V10.1154V6.74374H7.42829H6.37667V10.1154V13.487H5.86289H5.34912V10.1154V6.74374H4.27341H3.19769V10.1138Z\" fill=\"black\" data-v-727789cc></path><path d=\"M1.51675 15.2197C1.36262 15.2727 1.24542 15.3754 1.17156 15.5263C1.13463 15.597 1.13463 15.6114 1.12982 16.236L1.125 16.875H8.95362H16.7838L16.7774 16.252L16.7726 15.6307L16.7277 15.5328C16.6731 15.414 16.5462 15.2855 16.4354 15.2341L16.3552 15.1972L8.97771 15.194C1.91172 15.1908 1.59703 15.1908 1.51675 15.2197Z\" fill=\"black\" data-v-727789cc></path></g><defs data-v-727789cc><clipPath id=\"clip0_2328_26181\" data-v-727789cc><rect width=\"18\" height=\"18\" fill=\"white\" data-v-727789cc></rect></clipPath></defs></svg></div>", 1)),
                  (_ctx.isSidebarToggle)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["item-name leading-5 text-sm pl-2", _ctx.selectedOptionName === 'root-kpis'? 'text-white font-bold' : 'text-listIconColor font-normal'])
                      }, "KPIs", 2))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.sidebar.root_kpis && !_ctx.isSidebarToggle)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["px-2 text-white", _ctx.selectedOptionName === 'root-kpis'?'font-bold':'font-normal'])
                    }, "KPIs", 2)
                  ]))
                : _createCommentVNode("", true)
            ], 34)
          ]),
          _createElementVNode("ul", _hoisted_13, [
            _createElementVNode("li", _hoisted_14, [
              _cache[18] || (_cache[18] = _createElementVNode("hr", { class: "mb-4" }, null, -1)),
              (_ctx.isSidebarToggle)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _imports_2,
                    class: "icon arrowIcon leftarrow absolute cursor-pointer",
                    alt: "",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.toggleSideMenuBar()))
                  }))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _imports_3,
                    class: "arrowiconRight icon rightarrow absolute cursor-pointer",
                    alt: "",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.toggleSideMenuBar()))
                  }))
            ]),
            (_ctx.userInfo.currentRole == 10207)
              ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                  _createElementVNode("a", {
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.triggerNavToSettings())),
                    class: "flex navchild py-1 pl-2.5"
                  }, [
                    _createElementVNode("img", {
                      src: _imports_4,
                      class: _normalizeClass(["h-5 icon", { 'pr-1.5': _ctx.isSidebarToggle, '': !_ctx.isSidebarToggle }])
                    }, null, 2),
                    (_ctx.isSidebarToggle)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, "Settings"))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.userInfo.organisationType == 10701)
              ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                  _createElementVNode("a", {
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.triggerNavToAdminSettings())),
                    class: "flex navchild py-1 pl-2.5"
                  }, [
                    _createElementVNode("img", {
                      src: _imports_4,
                      class: _normalizeClass(["h-5 icon mr-2", { 'widthOpen': _ctx.isSidebarToggle, 'w-4': !_ctx.isSidebarToggle }])
                    }, null, 2),
                    (_ctx.isSidebarToggle)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Settings"))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["content mt-12 flex-1 min-w-0 w-full overflow-hidden", { toggledstate: _ctx.isSidebarToggle }]),
        onScroll: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["page", _ctx.flag ? 'margin-bottom1' : 'margin-bottom2'])
        }, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 2),
        _createVNode(_component_Footer, { class: "bg-dark-blue" })
      ], 34)
    ]),
    _createVNode(_component_detailsModalHost)
  ]))
}